const JwtDecode = require('./jwt-decode');

module.exports = {
  ReadAccessToken: function ReadAccessToken(accessTokenCookie) {
    const accessToken = JwtDecode.JwtDecode(accessTokenCookie);
    const coalescedAccessToken = accessToken || {
      loginTypeId: '',
      jti: '',
      extranetId: '',
      pod: '',
      sub: '',
      given_name: '',
      exp: 0
    };
    const authenticated = accessToken !== null;
    const isIpUser = authenticated && accessToken && accessToken.loginTypeId === '2';
    const pod = accessToken ? (accessToken.pod ? accessToken.pod : 'na1') : '';

    return {
      authenticated: authenticated,
      isIpUser: isIpUser,
      loginTypeId: coalescedAccessToken.loginTypeId,
      userId: coalescedAccessToken.jti,
      extranetId: coalescedAccessToken.extranetId,
      pod: pod.toLowerCase(),
      email: coalescedAccessToken.sub,
      firstName: coalescedAccessToken.given_name,
      expires: parseInt(coalescedAccessToken.exp, 10) || 0,
    };
  },
  IsInRole: function IsInRole(accessTokenCookie, role) {
    const accessToken = JwtDecode.JwtDecode(accessTokenCookie);

    if (accessToken == null) return false;
    
    const coalescedRoles = accessToken.roles || { roles: '[]'};
    const roles = JSON.parse(coalescedRoles);

    if (typeof (roles) === typeof ([])) {
      return roles.indexOf(role) > -1;
    }
    
    return false;
  }
};
